import {
    StyledDropdown,
    StyledLabel,
    Wrapper
} from './SearchInitiationMobile.styles';

const durationOptions = {
    '900': '15 minutes',
    '1800': '30 minutes',
    '2700': '45 minutes',
    '3600': '1 hour',
    '4500': '1 ¼ hour'
};

export type Duration = keyof typeof durationOptions;

type SelectMaxTravelTimeProps = {
    value: Duration;
    onChange: (duration: Duration) => void;
};

export const SelectMaxTravelTime = ({
    value,
    onChange
}: SelectMaxTravelTimeProps) => {
    const durationLabel = 'Max travel time';

    return (
        <Wrapper>
            <StyledLabel>{durationLabel}</StyledLabel>
            <StyledDropdown
                id="duration_mobile"
                onChange={(e) => {
                    onChange(e.target.value as Duration);
                }}
                value={value}
                name="duration"
                aria-label="Max travel time"
                data-testid="select-max-travel-time-dropdown_mobile"
            >
                {Object.keys(durationOptions).map((duration, index) => {
                    return (
                        <option
                            value={duration}
                            key={`mobile_duration_${index}`}
                        >
                            {durationOptions[duration as Duration]}
                        </option>
                    );
                })}
            </StyledDropdown>
        </Wrapper>
    );
};
